import React, { useState } from "react";

import {
    Box,
    Typography,
    useMediaQuery,
    useTheme,
    Container,
    Button,
    Stack,
} from "@mui/material";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import { Tribuja } from "../../assets";

const Gallery = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [tab, setTab] = useState(0);

    // ================= IMAGES =================

    const interiorImages = [
        "https://dprstorage.b-cdn.net/RW/tribuja/5.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/21.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/23.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/20.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/15.png",
    ];

    const exteriorImages = [
        "https://dprstorage.b-cdn.net/RW/tribuja/8.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/4.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/18.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/10.png",

        "https://dprstorage.b-cdn.net/RW/tribuja/13.png",
    ];

    const images = tab === 0 ? interiorImages : exteriorImages;

    // ================= TAB CHANGE =================

    const handleTabChange = (
        direction: "prev" | "next"
    ) => {
        if (direction === "next") {
            setTab((prev) => (prev === 1 ? 0 : prev + 1));
        } else {
            setTab((prev) => (prev === 0 ? 1 : prev - 1));
        }
    };

    return (
        <Box
            sx={{
                position: "relative",

                width: "100%",

                overflow: "hidden",

                backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg2.webp")`,

                backgroundSize: "cover",

                backgroundPosition: "center",

                py: {
                    xs: 8,
                    md: 6,
                },

                "&::after": {
                    content: '""',

                    position: "absolute",

                    inset: 0,

                    background:
                        "linear-gradient(to bottom, rgba(0,0,0,0.68), rgba(0,0,0,0.68))",

                    zIndex: 1,
                },
            }}
        >
            {/* BLUE GLOW */}

            <Box
                sx={{
                    position: "absolute",

                    top: "-200px",

                    right: "-100px",

                    width: {
                        xs: "300px",
                        md: "700px",
                    },

                    height: {
                        xs: "300px",
                        md: "700px",
                    },

                    background:
                        "radial-gradient(circle, rgba(48,119,157,0.35) 0%, rgba(48,119,157,0) 70%)",

                    filter: "blur(120px)",

                    zIndex: 1,
                }}
            />

            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 5,
                }}
            >
                {/* ================= TITLE ================= */}

                <Box textAlign="center" mb={3}>


                    <Typography
                        variant="h4"
                        sx={{

                            fontFamily: "Luxury",
                            fontWeight: 500,

                            color: "#fff",

                            letterSpacing: "4px",

                            textTransform: "uppercase",

                            mb: 2,
                        }}
                    >
                        Gallery
                    </Typography>
                    <Box
                        sx={{
                            width: {
                                xs: "120px",
                                md: "180px",
                            },

                            height: "2px",

                            background:
                                "linear-gradient(to right, transparent, #fff, transparent)",

                            mx: "auto",

                            mb: 3,
                        }}
                    />
                </Box>

                {/* ================= MODERN TABS ================= */}

                <Box
                    sx={{
                        display: "flex",

                        justifyContent: "center",

                        alignItems: "center",

                        gap: 2,

                        mb: 4,
                    }}
                >
                    {/* LEFT */}

                    <Box
                        onClick={() => handleTabChange("prev")}
                        sx={{
                            width: 40,

                            height: 40,

                            borderRadius: "50%",

                            display: {xs:"none",md:"flex"},

                            alignItems: "center",

                            justifyContent: "center",

                            cursor: "pointer",

                            background:
                                "rgba(255,255,255,0.06)",

                            border:
                                "1px solid rgba(255,255,255,0.12)",

                            color: "white",

                            backdropFilter: "blur(10px)",

                            transition: "0.4s",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg,#30779d,silver)",

                                transform: "translateX(-4px)",
                            },
                        }}
                    >
                        <ArrowBackIosNewRoundedIcon
                            sx={{
                                fontSize: 18,
                            }}
                        />
                    </Box>

                    {/* TABS */}

                    <Stack direction="row" spacing={2}>
                        {["INTERIOR", "EXTERIOR"].map(
                            (label, index) => {
                                const active = tab === index;

                                return (
                                    <Box
                                        key={label}
                                        sx={{
                                            position: "relative",
                                        }}
                                    >
                                        <Button
                                            onClick={() => setTab(index)}
                                            sx={{
                                                fontFamily: "Season",
                                                minWidth: {
                                                    xs: "150px",
                                                    md: "180px",
                                                },

                                                height: {
                                                    xs: "54px",
                                                    md: "45px",
                                                },

                                                borderRadius: "60px",

                                                border: active
                                                    ? "1px solid silver"
                                                    : "1px solid rgba(255,255,255,0.12)",

                                                background: active
                                                    ? "linear-gradient(135deg,#30779d,silver)"
                                                    : "rgba(255,255,255,0.05)",

                                                color: "white",

                                                backdropFilter:
                                                    "blur(18px)",

                                                fontWeight: 700,

                                                letterSpacing: 2,

                                                fontSize: {
                                                    xs: "13px",
                                                    md: "14px",
                                                },

                                                transition: "0.4s",

                                                boxShadow: active
                                                    ? "0px 10px 35px rgba(48,119,157,0.4)"
                                                    : "none",

                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(135deg,#30779d,silver)",
                                                },
                                            }}
                                        >
                                            {label}
                                        </Button>

                                        {/* ACTIVE ARROW */}

                                        {/* {active && (
                                            <Box
                                                sx={{
                                                    position: "absolute",

                                                    left: "50%",

                                                    transform:
                                                        "translateX(-50%)",

                                                    bottom: "-12px",

                                                    width: 0,

                                                    height: 0,

                                                    borderLeft:
                                                        "10px solid transparent",

                                                    borderRight:
                                                        "10px solid transparent",

                                                    borderTop:
                                                        "12px solid #30779d",
                                                }}
                                            />
                                        )} */}
                                    </Box>
                                );
                            }
                        )}
                    </Stack>

                    {/* RIGHT */}

                    <Box
                        onClick={() => handleTabChange("next")}
                        sx={{
                            width: 40,

                            height: 40,

                            borderRadius: "50%",

                            display: {xs:"none",md:"flex"},

                            alignItems: "center",

                            justifyContent: "center",

                            cursor: "pointer",

                            background:
                                "rgba(255,255,255,0.06)",

                            border:
                                "1px solid rgba(255,255,255,0.12)",

                            color: "white",

                            backdropFilter: "blur(10px)",

                            transition: "0.4s",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg,#30779d,silver)",

                                transform: "translateX(4px)",
                            },
                        }}
                    >
                        <ArrowForwardIosRoundedIcon
                            sx={{
                                fontSize: 18,
                            }}
                        />
                    </Box>
                </Box>

                {/* ================= MODERN GRID ================= */}

                {/* ================= MODERN GRID ================= */}

                <Box
                    sx={{
                        display: "grid",

                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "0.9fr 1.1fr 0.9fr",
                        },

                        gap: {
                            xs: 1.5,
                            md: 2,
                        },

                        alignItems: "center",

                        maxWidth: "1250px",

                        mx: "auto",
                    }}
                >
                    {/* LEFT */}

                    <Stack spacing={2}>
                        <LuxuryImage
                            src={images[0]}
                            height={isMobile ? 180 : 200}
                        />

                        <LuxuryImage
                            src={images[1]}
                            height={isMobile ? 230 : 250}
                        />
                    </Stack>

                    {/* CENTER */}

                    <LuxuryImage
                        src={images[2]}
                        height={isMobile ? 320 : 470}
                        large
                    />

                    {/* RIGHT */}

                    <Stack spacing={2}>
                        <LuxuryImage
                            src={images[3]}
                            height={isMobile ? 230 : 250}
                        />

                        <LuxuryImage
                            src={images[4]}
                            height={isMobile ? 180 : 200}
                        />
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
};

// ================= IMAGE CARD =================

const LuxuryImage = ({
    src,
    height,
    large,
}: {
    src: string;
    height: number;
    large?: boolean;
}) => {
    return (
        <Box
            sx={{
                position: "relative",

                width: "100%",

                height,

                overflow: "hidden",

                borderRadius: large
                    ? "34px"
                    : "28px",

                cursor: "pointer",

                background:
                    "rgba(255,255,255,0.04)",

                border:
                    "1px solid rgba(255,255,255,0.08)",

                backdropFilter: "blur(12px)",

                transition: "0.6s ease",

                "&:hover": {
                    transform: "translateY(-6px)",

                    "& img": {
                        transform: "scale(1.08)",
                    },

                    "& .overlay": {
                        opacity: 1,
                    },
                },
            }}
        >
            {/* IMAGE */}

            <Box
                component="img"
                src={src}
                alt="gallery"
                sx={{
                    width: "100%",

                    height: "100%",

                    objectFit: "cover",

                    transition: "0.7s ease",
                }}
            />

            {/* OVERLAY */}

            <Box
                className="overlay"
                sx={{
                    position: "absolute",

                    inset: 0,

                    background:
                        "linear-gradient(to top, rgba(0,0,0,0.75), transparent)",

                    opacity: 0,

                    transition: "0.5s ease",
                }}
            />

            {/* SHINE EFFECT */}

            <Box
                sx={{
                    position: "absolute",

                    top: 0,

                    left: "-100%",

                    width: "50%",

                    height: "100%",

                    background:
                        "linear-gradient(to right, transparent, rgba(255,255,255,0.12), transparent)",

                    transform: "skewX(-25deg)",

                    transition: "0.8s",

                    ".MuiBox-root:hover &": {
                        left: "130%",
                    },
                }}
            />
        </Box>
    );
};

export default Gallery;